export default "__VITE_ASSET___948vsF6__"